import { Box, Button } from '@mui/material'
import React from 'react'
import { SortingArrows } from './SortingArrows'

export interface SortableHeaderProps {
  id: string
  title: string
  isSorting: boolean
  isAscending: boolean
  onToggle: (id: string) => void
}

/**
 * Renders a sortable table header button with sorting state indicators.
 * @param id - Sort field identifier
 * @param title - Displayed header text
 * @param isSorting - Whether this column is currently sorted
 * @param isAscending - Whether the current sort is ascending
 * @param onToggle - Callback invoked when sorting is toggled
 */
export function SortableHeader({
  id,
  title,
  isSorting,
  isAscending,
  onToggle,
}: SortableHeaderProps) {
  return (
    <Box>
      <Button id={id} onClick={() => onToggle(id)}>
        {`↑↓ ${title} `}
        <SortingArrows isSorting={isSorting} isAscending={isAscending} />
      </Button>
    </Box>
  )
}
